import { atom } from 'recoil';
import { CartItem } from '~/types';

const cartItems = atom<Array<CartItem>>({
  key: 'cartItems',
  default: [],
});

export default cartItems;
